import { render, staticRenderFns } from "./EventTheme.vue?vue&type=template&id=35d9067c&scoped=true"
import script from "./EventTheme.vue?vue&type=script&lang=ts"
export * from "./EventTheme.vue?vue&type=script&lang=ts"
import style0 from "./EventTheme.vue?vue&type=style&index=0&id=35d9067c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d9067c",
  null
  
)

export default component.exports